import { useState } from 'react';

const UserHeader = ({ user }) => {

  const { name, surname, avatarUrl } = user;

  return (
    <div className='mini-user-box'>
      <div className='mini-user-info'>{name}</div>
      <div className='mini-user-info'>{surname}</div>
      <div className="user-header-icon"><img src={avatarUrl} /></div>
    </div>
  )
}

export default UserHeader;
